import React, {useEffect} from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../../ui/TextField";
import DataSelect from "../../../../../../../../ui/DataSelect";
import Progress from "../../../../../../../../ui/Progress";
import Tooltip from "@material-ui/core/Tooltip";
import InfoField from "../../../../../../../../ui/InfoDrawer/components/InfoField";
import IconButton from "@material-ui/core/IconButton";
import UploadDropzone from "../../../../../../../../ui/FileIUpload/UploadDropzone";
import ClearIcon from '@material-ui/icons/Clear';
import AttachmentCard from "../../../../../../../../ui/AttachmentCard";

import {updateProgramFile, updateProgramLogo, updateCertificate} from "../../../../store/send";
import {deleteProgramLogo, deleteProgramFile, deleteCertificate} from "../../../../store/deleteactions";
import {
  getDictOrganizations,
  getDictWsCategories,
  getSkillsByCategory,
  getDictTrialForms,
  getDictEduForms,
  getDictTargetGroups,
  getDictMunicipals
} from "../../../../../../../../Dict/store/actions";

import { loadList as getDictRegions } from "../../../../../../../../Dict/Region/View/fetch";
import { getSpecialities } from "../../../../../../../../Dict/Skills/Speciality/store/actions";
import ViewPageLayout from "../../../../../../../../ui/ViewPageLayout";
import Checkbox from "../../../../../../../../ui/Checkbox";


const styles = () => ({
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  typofield: {
    width: 120,
    minWidth: 120,
    paddingRight: 16
  },
  typovalue: {
    fontSize: 12,
  },
  dropzoneWraper: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  dropZoneButtonArea: {
    width: 75,
    height: 35,
    zIndex: 1000,
    position: "absolute",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  iconButton: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent"
    }
  }
});

const defaultData = {
  duration: null,
  code: "",
  name: "",
  subtitle: "",
  qualification: "",
  targetGroup: null,
  speciality: null,
  skill: null,
  category: null,
  municipal: null,
  organization: null,
  year: null,
  educationForm: null,
  trialForm: null,
  description: "",
  keyWords: "",
  published: false,
  stop: false,
  onMainPage: false,
  mainPageSort: null,
  price: null
};

const ProgramMainInfoView = ({
classes,
programInfo,
programData,
programFile,
certificateFile,
disabled,
onFormChange,
programId,
updateProgramFile,
updateProgramLogo,
updateCertificate,
deleteProgramLogo,
deleteProgramFile,
deleteCertificate,
getDictOrganizations, organizations,
getDictWsCategories, categories,
getSkillsByCategory, skills,
getDictRegions, regions,
getDictMunicipals, municipals,
getSpecialities, specialities,
getDictEduForms, eduFormList,
getDictTargetGroups, targetGroupList,
getDictTrialForms, trialFormList
}) => {
  const [data, setData] = React.useState(defaultData);

  useEffect(() => {
    if (programData) {
      setData(programData);
    }
  }, [programData]);

  useEffect(() => {
    getDictRegions();
    getDictWsCategories();
    getSpecialities();
    getDictTargetGroups();
    getDictTrialForms();
    getDictEduForms();
  }, [getDictEduForms, getDictRegions, getDictTargetGroups, getDictTrialForms, getDictWsCategories, getSpecialities]);

  useEffect(() => {
    if (data && data.region && data.region > -1) {
      let regionId = data.region;
      getDictOrganizations(regionId);
      getDictMunicipals(regionId);
    }
  }, [data, getDictMunicipals, getDictOrganizations]);

  useEffect(() => {
    if (data && data.category && data.category > -1)
      getSkillsByCategory(data.category);
  }, [data, getSkillsByCategory]);

  const UploadProgramLogo = files => {
    if (programId && programId > -1 && files.length > 0) {
      updateProgramLogo(programId, files[0]);
    }
  };

  const UploadProgramFile = files => {
    if (programId && programId > -1 && files.length > 0) {
      updateProgramFile(programId, files[0]);
    }
  }

  const UploadCertificateFile = files => {
    if (programId && programId > -1 && files.length > 0) {
      updateCertificate(programId, files[0]);
    }
  }

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange && onFormChange(newState);
  };

  return(
    <ViewPageLayout header="Основные сведения" fullWidth>
      {data ? <>
        <Grid container spacing={1} className={classes.mainGrid}>
          <Grid item xs={6} sm={3} lg={1}>
            <TextField
              value={programInfo.id || ""}
              label="ID"
              disabled={true}
            />
          </Grid>
          <Grid item xs={6} sm={3} lg={1}>
            <TextField
              value={data.code || ""}
              label="Код"
              onChange={e => onChange("code", e.target.value)}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={10}>
            <TextField
              required
              value={data.name || ""}
              label="Наименование (Заголовок)"
              onChange={e => onChange("name", e.target.value)}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              value={data.subtitle || ""}
              onChange={e => onChange("subtitle", e.target.value)}
              label="Таргетированный заголовок"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              value={data.keyWords || ""}
              onChange={e => onChange("keyWords", e.target.value)}
              label="Ключевые слова"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {categories &&
            <DataSelect
              value={data.category}
              dataSource={categories}
              label="Направление"
              disabled={disabled}
              onChange={value => onChange("category", value._key)}
              keyField="_key"
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {skills &&
            <DataSelect
              value={data.skill}
              dataSource={skills}
              label="Компетенция"
              onChange={value => onChange("skill", value._key)}
              disabled={disabled}
              keyField="_key"
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {specialities &&
            <DataSelect
              value={data.speciality}
              getOptionLabel={option => option && `${option.code} | ${option.name}`}
              dataSource={specialities}
              label="Профессия/Специальность"
              onChange={value => onChange("speciality", value.id)}
              disabled={disabled}
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              value={data.qualification || ""}
              label="Присваеваемый квалификационный разряд"
              disabled={disabled}
              onChange={e => onChange("qualification", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            {regions &&
            <DataSelect
              value={data.region}
              dataSource={regions}
              disabled={disabled}
              onChange={value => onChange("region", value.id)}
              label="Регион"
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {municipals &&
            <DataSelect
              value={data.municipal}
              dataSource={municipals}
              disabled={disabled}
              onChange={value => onChange("municipal", value._key)}
              label="Город/Поселение"
              required
              keyField="_key"
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {organizations &&
            <DataSelect
            value={data.organization}
            label="Реализуется партнёром"
            onChange={value => onChange("organization", value._key)}
            dataSource={organizations}
            disabled={disabled}
            required
            keyField="_key"
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {targetGroupList &&
            <DataSelect
              value={data.targetGroup}
              label="Для кого"
              onChange={value => onChange("targetGroup", value._key)}
              dataSource={targetGroupList}
              disabled={disabled}
              keyField="_key"
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {eduFormList &&
            <DataSelect
              value={data.educationForm}
              label="Форма обучения"
              onChange={value => onChange("educationForm", value._key)}
              dataSource={eduFormList}
              disabled={disabled}
              keyField="_key"
            />}
          </Grid>
            <Grid item xs={6} md={3}>
              {trialFormList &&
              <DataSelect
                value={data.trialForm}
                label="Форма аттест."
                onChange={value => onChange("trialForm", value._key)}
                dataSource={trialFormList}
                disabled={disabled}
                keyField="_key"
              />}
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.year || ""}
                label="Год"
                disabled={disabled}
                onChange={e => onChange("year", e.target.value)}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.duration || ""}
                label="Объём"
                disabled={disabled}
                onChange={e => onChange("duration", e.target.value)}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.price || ""}
                type="number"
                onChange={e => onChange("price", e.target.value)}
                label="Стоимость"
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <Checkbox checked={data.published || false}
                        disabled={disabled}
                        handleChange={(_, val) => onChange("published", val)}
                        label="Опубликована"/>
            </Grid>
            <Grid item xs={6} md={3}>
              <Checkbox checked={data.stop || false}
                        disabled={disabled}
                        handleChange={(_, val) => onChange("stop", val)}
                        label="Закрыто для записи"/>
            </Grid>
            <Grid item xs={6} md={3}>
              <Checkbox checked={data.onMainPage || false}
                        disabled={disabled}
                        handleChange={(_, val) => onChange("onMainPage", val)}
                        label="На главной"/>
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.mainPageSort || ""}
                type="number"
                onChange={e => onChange("mainPageSort", e.target.value)}
                label="Порядок на главной"
                disabled={disabled || !data.onMainPage}
              />
            </Grid>

          <Grid item xs={12}>
            <TextField
              value={data.description || ""}
              label="Описание"
              disabled={disabled}
              onChange={e => onChange("description", e.target.value)}
            />
          </Grid>
        </Grid>

          {/*<div className={classes.block}>
            <div className={classes.blockrow}>
              <Typography
                className={classes.typofield}
                variant="caption"
                color="textSecondary">
                Статус программы:
              </Typography>
              <Typography className={classes.typovalue} variant="caption">
                {ColoredStateIcon(programInfo.statusId)}
                <span style={{
                  color: StateTextColor(programInfo.statusId)
                }}>{programInfo.statusName}</span>
              </Typography>
            </div>
            <div className={classes.blockrow}>
              <CardInfoField field="Дата создания:" value={formatDate(programInfo.creationDate)} wide="true"/>
            </div>
            {programInfo.expertise &&
            <div className={classes.blockrow}>
              <CardInfoField field="Дата экспертизы:" value={formatDate(programInfo.expertise.statusDate)} wide="true"/>
            </div>
            }
            <div className={classes.blockrow}>
              <CardInfoField field="Дата публикации:" value={formatDate(programInfo.publicationDate)} wide="true"/>
            </div>
          </div>*/}

        <br/>
        <Typography className={classes.heading}>Загруженные файлы</Typography>
        <Grid container spacing={1} className={classes.mainGrid}>
          <Grid item xs={12} md={6}>
            <div>
              <InfoField name="Файл рабочей программы" />
              <div>
                {programFile ? (
                  <AttachmentCard
                    id={programFile.fileId}
                    mimeType={programFile.mimeType}
                    fileName={programFile.fileName}
                    fileSize={programFile.size}
                    fileLink={programFile.fileId}
                    download
                    removeDocument={() => deleteProgramFile(programId)}
                  />
                ) : (
                  <UploadDropzone
                    onDrop={newFile => {
                      UploadProgramFile(newFile);
                    }}
                    accept={[".pdf"]}
                    maxSize={2000000}
                  />
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div>
              <InfoField name="Файл сертификата" />
              <div>
                {certificateFile ? (
                  <AttachmentCard
                    id={certificateFile.fileId}
                    mimeType={certificateFile.mimeType}
                    fileName={certificateFile.fileName}
                    fileSize={certificateFile.size}
                    fileLink={certificateFile.fileId}
                    download
                    removeDocument={() => deleteCertificate(programId)}
                  />
                ) : (
                  <UploadDropzone
                    onDrop={newFile => {
                      UploadCertificateFile(newFile);
                    }}
                    accept={[".pdf",".png",".jpg"]}
                    maxSize={2000000}
                  />
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div>
              <InfoField name="Изображение карточки" />
              <div className={classes.dropzoneWraper}>
                <div className={classes.dropZoneButtonArea}>
                  <Tooltip title="Удалить" placement="top">
                    <IconButton
                      classes={{ root: classes.iconButton }}
                      onClick={() => deleteProgramLogo(programInfo.id)}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                <UploadDropzone
                  type="card"
                  fileId={programInfo.logo}
                  accept={[".jpg", ".jpeg", ".png"]}
                  onDrop={image => {
                    UploadProgramLogo(image);
                  }}
                />
              </div>
            </div>
          </Grid>
        </Grid></> :
      <div className={classes.progress}>
        <Progress />
      </div>}
    </ViewPageLayout>
  );
}

const mapStateToProps = state => ({
  isUpdatingProgram: state.programs.isUpdatingProgram,
  organizations: state.dictAll.organizationList,
  categories: state.dictAll.wsCategoryList,
  skills: state.dictAll.skillList,
  municipals: state.dictAll.municipalList,
  //regions: state.dictAll.regionList,
  regions: state.dictRegionView.list,
  specialities: state.specialities.specialities,
  targetGroupList: state.dictAll.targetGroupList,
  trialFormList: state.dictAll.trialFormList,
  eduFormList: state.dictAll.eduFormList
});

const mapDispatchToProps = dispatch => ({
  getDictOrganizations: (regionId) => dispatch(getDictOrganizations(regionId)),
  getDictWsCategories: () => dispatch(getDictWsCategories()),
  getSkillsByCategory: (categoryId) => dispatch(getSkillsByCategory(categoryId)),
  getDictRegions: () => dispatch(getDictRegions()),
  getDictMunicipals: (regionId) => dispatch(getDictMunicipals(regionId)),
  getSpecialities: () => dispatch(getSpecialities()),
  getDictTargetGroups: () => dispatch(getDictTargetGroups()),
  getDictTrialForms: () => dispatch(getDictTrialForms()),
  getDictEduForms: () => dispatch(getDictEduForms()),
  updateProgramLogo: (id, file) => dispatch(updateProgramLogo(id, file)),
  updateProgramFile: (id, file) => dispatch(updateProgramFile(id, file)),
  updateCertificate: (id, file) => dispatch(updateCertificate(id, file)),
  deleteProgramLogo: (id) => dispatch(deleteProgramLogo(id)),
  deleteProgramFile: (id) => dispatch(deleteProgramFile(id)),
  deleteCertificate: (id) => dispatch(deleteCertificate(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProgramMainInfoView));
